import { cards } from '@/mocks/cards';

export default function Cards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              图文资讯
            </h2>
            <p className="text-sm text-foreground-500 mt-1">最新娱乐动态一览</p>
          </div>
          <div className="flex gap-2">
            {['最新', '最热', '影视', '综艺', '八卦'].map((tab) => (
              <button
                key={tab}
                className={`text-xs px-3 py-1.5 rounded-full transition-colors whitespace-nowrap cursor-pointer ${
                  tab === '最新'
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-200 text-foreground-600 hover:bg-background-300'
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {cards.slice(0, 7).map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-background-300 transition-colors group cursor-pointer"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-[10px] bg-primary-500 text-background-50 px-2 py-0.5 rounded-full font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-900 mb-2 line-clamp-2 leading-snug">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                  {item.desc}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span><i className="ri-time-line mr-1"></i>{item.time}</span>
                  <span><i className="ri-eye-line mr-1"></i>{item.views}阅读</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {cards.length === 7 && (
          <div className="mt-6 text-center">
            <span className="text-xs text-foreground-400 bg-background-200/70 px-4 py-2 rounded-full">
              查看更多资讯 <i className="ri-arrow-down-line text-[10px]"></i>
            </span>
          </div>
        )}
      </div>
    </section>
  );
}